'use strict';

/* global $ */


import { interfaceName } from './settings';

import { AjaxForm } from './modules/ajax-form';
import { Goal } from './modules/goal';
import { Responsive } from './modules/responsive';
import { Header } from './modules/header';
import { Menu } from './modules/menu';
import { Slider } from './modules/slider';
import { Questions } from './modules/questions';
import { Popup } from './modules/popup';

class Proj {
    constructor() {
        this.init();
    }
    init() {
        this.interfaceName = interfaceName;

        new WOW().init();
        this.ajaxForm = new AjaxForm();
        this.goal = new Goal({
            goals: [
                {
                    selector: '.js-goal__link',
                    event: 'click',
                    handler() {
                        $(window).trigger('goal.main', $(this).data());
                    }
                }, {
                    selector: '.js-goal__form',
                    event: 'submit',
                    handler() {
                        $(window).trigger('goal.main', $(this).data());
                    }
                }
            ]
        });

        this.responsive = new Responsive();

        $('[data-fancybox]').fancybox({
            thumbs : {
                autoStart : false,
                axis: 'x'
            },
            transitionEffect: 'zoom-in-out',
            slideShow: {
                autoStart: false,
                speed: 2000,
            },
            loop: true,
            backFocus: false,
            lang: 'ru',
            i18n: {
                ru: {
                    CLOSE: 'Закрыть',
                    NEXT: 'Следующий',
                    PREV: 'Предыдущий',
                    ERROR: "Запрашиваемый контент не может быть загружен.<br/>Попробуйте позже.",
                    PLAY_START: 'Запустить слайдшоу',
                    PLAY_STOP: 'Остановить слайдшоу',
                    FULL_SCREEN: 'На весь экран',
                    THUMBS: 'Галерея превью',
                    DOWNLOAD: 'Скачать',
                    SHARE: 'Поделиться',
                    ZOOM: 'Увеличить'
                },
            },
            video: {
                tpl:
                  '<video class="fancybox-video" loop muted autoplay controlsList="nodownload" poster="{{poster}}">' +
                  '<source src="{{src}}" type="{{format}}" />' +
                  'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
                  "</video>",
                format: "",
                autoStart: true
            },
        });

        this.header = new Header({selector: '.js-header'});
        this.menu = new Menu({selector: '.js-menu'});
        this.popup = new Popup();
        this.questions = new Questions({selector: '.js-questions'});
        this.initHeaderSlider();
        this.initGallerySlider();

        if (this.interfaceName == 'room_page') {
            this.initRoomSlider();
        }
    }

    initHeaderSlider() {
        console.log('[ HeaderSlider/Init ]');
        this.HeaderSlider = new Slider({
            selector: '.js-header-slider',
            show: 1,
            scroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            autoplay: true,
            autoplayspeed: 5000,
            //slide: 'slider__item',
            //prev: '.js-room__slider-prev',
            //next: '.js-room__slider-next',
            rows: 0,
            perrorw: 1,
            adaptiveheight: false,
            //init: function(event, slick) {
            //},
            //before: function(event, slick, currentSlide, nextSlide) {
            //},
            //after: function(slick, currentSlide) {
            //},
        });
    }

    initGallerySlider() {
        console.log('[ GallerySlider/Init ]');
        this.GallerySlider = new Slider({
            selector: '.js-gallery-slider',
            show: 4,
            scroll: 1,
            arrows: false,
            dots: true,
            fade: false,
            autoplay: true,
            autoplayspeed: 5000,
            //centermode: true,
            infinite: true,
            //variablewidth: true,
            //slide: 'slider__item',
            //prev: '.js-room__slider-prev',
            //next: '.js-room__slider-next',
            rows: 0,
            perrorw: 1,
            adaptiveheight: false,
            //init: function(event, slick) {
            //},
            //before: function(event, slick, currentSlide, nextSlide) {
            //},
            //after: function(slick, currentSlide) {
            //},
        });
    }

    initRoomSlider() {
        console.log('[ RoomSlider/Init ]');
        this.RoomSlider = new Slider({
            selector: '.js-room__slider',
            show: 1,
            scroll: 1,
            arrows: true,
            dots: true,
            fade: true,
            speed: 1000,
            //slide: 'slider__item',
            prev: '.js-room__slider-prev',
            next: '.js-room__slider-next',
            rows: 0,
            perrorw: 1,
            adaptiveheight: false,
            //init: function(event, slick) {
            //},
            //before: function(event, slick, currentSlide, nextSlide) {
            //},
            //after: function(slick, currentSlide) {
            //},
        });
    }
}

$(function() {
    window.proj = new Proj();
});
